module.exports = {"pageTitleText":"HTML Pages","createText":"Create","groupName":"Group Name","htmlPageName":"Page Name","status":"Status","sections":{"essential":"Essential"},"isPresentHtmlPageFromLocal":"Present HTML Page from local"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/htmlPage.json
// module id = Qf2z
// module chunks = 3